import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostVorlageCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostVorlageCommandService],
  exports: []
})
export class PostVorlageCommandServiceModule { }
